// extracted by mini-css-extract-plugin
export default {"wrapper":"NewFeatures_wrapper__xAexe","iconWrapper":"NewFeatures_iconWrapper__2LtcO","contentArea":"NewFeatures_contentArea__9+f0J"};